import { Claim } from "../plasma-ui-common/synlab-access-ui-components/core";

export function claimsToObject(claims: Claim[]): Record<string, string> {
  return claims.reduce((accumulator, value) => {
    accumulator[value.claimType] = value.claimValue ?? "";
    return accumulator;
  }, {});
}
